import React from 'react';
import { useOutletContext } from 'react-router-dom';
import MapView from './MapView';

export default function MapPage() {
  const {
    mapRef, onReady, onShowInfo,
    onSelectDevice, forceOpenPanel, onMapMove
  } = useOutletContext();

  return (
    <MapView
      ref={mapRef}
      onReady={onReady}
      onShowInfo={onShowInfo}
      onSelectDevice={onSelectDevice}
      forceOpenPanel={forceOpenPanel}
      onMapMove={onMapMove}
    />
  );
}
